import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register plugin if not already done globally
gsap.registerPlugin(ScrollTrigger);

// --- SVG Icons (Keep as is) ---
const WaterDropIcon = () => (<svg viewBox="0 0 64 64" fill="currentColor"><path d="M32 2C32 2 12 24 12 38C12 52.15 21.85 62 36 62C50.15 62 60 52.15 60 38C60 24 40 2 32 2Z" /></svg>);
const BuildingIcon = () => (<svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 9h-2V7h2v2zm-4 0H7v10h8V9zm6-4H3v16h18V5zm-2 14H5V7h14v12zM15 11h-2v2h2v-2zm0 4h-2v2h2v-2zM11 11H9v2h2v-2zm0 4H9v2h2v-2z" /></svg>);
const HomeIcon = () => (<svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5z" /></svg>);
const SignboardIcon = () => (<svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 4h16v3H4V4zm0 5h16v11H4V9zm2 2v7h12v-7H6zm10 2h-2v3h2v-3zm-4 0h-2v3h2v-3z" /></svg>);

function Services() {
  const elementsRef = useRef([]);
  const sectionRef = useRef(null);
  // Removed refs and state related to the button (ctaButtonRef, originalButtonContainerRef, isFloating)

  useEffect(() => {
    // --- Service Items Animation (Existing) ---
    const serviceItems = elementsRef.current.filter(el => el);
    let itemTriggers = []; // Store triggers for cleanup

    serviceItems.forEach((item) => {
      const icon = item.querySelector('svg');
      const heading = item.querySelector('h3');
      const paragraph = item.querySelector('p');
      const tl = gsap.timeline({
        // Give each trigger a unique ID for potential cleanup
        scrollTrigger: {
          id: `service-${item.textContent.substring(0, 10)}`, // Example ID
          trigger: item, start: 'top 85%', end: 'bottom 20%',
          toggleActions: 'play none none reverse',
        }
      });
      tl.fromTo(item, { opacity: 0.5, scale: 0.95 }, { opacity: 1, scale: 1, duration: 0.5, ease: 'power2.out' })
        .fromTo([icon, heading, paragraph], { opacity: 0, y: 30, rotationX: -30 }, { opacity: 1, y: 0, rotationX: 0, duration: 0.6, ease: 'power3.out', stagger: 0.15 }, "-=0.3");

      // Store the ScrollTrigger instance associated with the timeline
      if (tl.scrollTrigger) {
        itemTriggers.push(tl.scrollTrigger);
      }
    });

    // --- Button Logic Removed ---

    // --- Cleanup Function ---
    return () => {
      // Kill only the ScrollTriggers created in this component
      itemTriggers.forEach(trigger => trigger.kill());
      // Ensure any direct tweens on items are also killed if necessary
      serviceItems.forEach(item => gsap.killTweensOf(item));
      // Kill tweens of child elements if they weren't part of the timeline
      serviceItems.forEach(item => {
        const icon = item.querySelector('svg');
        const heading = item.querySelector('h3');
        const paragraph = item.querySelector('p');
        gsap.killTweensOf([icon, heading, paragraph]);
      });
    };

  }, []); // Run only once on mount

  return (
    <section id="services" ref={sectionRef}>
      <div className="container">
        <h2>제공 서비스</h2>
        <div className="services-grid">
          {/* Service items */}
          <div className="service-item" ref={(el) => (elementsRef.current[0] = el)}>
            <HomeIcon />
            <h3>아파트, 상가 창문 청소</h3>
            <p>아파트, 주택, 상가 등 다양한 공간의 창문을 안팎으로 투명하게 만들어 드립니다.</p>
          </div>
          <div className="service-item" ref={(el) => (elementsRef.current[1] = el)}>
            <BuildingIcon />
            <h3>빌딩 외벽 관리</h3>
            <p>고층 빌딩, 상업 시설의 외벽을 전문 장비로 안전하고 깨끗하게 세척합니다.</p>
          </div>
          <div className="service-item" ref={(el) => (elementsRef.current[2] = el)}>
            <WaterDropIcon />
            <h3>사무실, 건물 정기 관리</h3>
            <p>사무실, 빌딩의 쾌적한 환경 유지를 위해 맞춤형 정기 청소 및 관리 서비스를 제공합니다.</p>
          </div>
          <div className="service-item" ref={(el) => (elementsRef.current[3] = el)}>
            <SignboardIcon />
            <h3>간판 및 어닝 청소</h3>
            <p>상가 간판과 어닝을 깨끗하게 관리하여 매장의 첫인상을 밝고 선명하게 만들어드립니다.</p>
          </div>
        </div>

        {/* --- Button and its container REMOVED from here --- */}

      </div>
    </section>
  );
}

export default Services;